import PropTypes from 'prop-types';
import { memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Link } from '@mui/material';
// components
import Image from '../image/Image';
import image from '../../assets/magscholar-logo.png';

// ----------------------------------------------------------------------

function Logo({ single = false, sx }) {
    const fullLogo = (
        <Image
            src={image}
            alt="MAGScholar-logo"
            sx={{ width: single ? 165 : 265, height: 'auto', ...sx }}
        />
    );

    return (
        <Link
            component={RouterLink}
            to="/"
            aria-label="go to homepage"
            sx={{ m: 1, p: 1 }}
        >
            {fullLogo}
        </Link>
    );
}

Logo.propTypes = {
    single: PropTypes.bool,
    sx: PropTypes.object,
};

export default memo(Logo);